import { render } from "./CookieButton.vue?vue&type=template&id=17ae9f54"
const script = {}

import "./CookieButton.vue?vue&type=style&index=0&id=17ae9f54&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__